/**
 * ProgressTab — media-query dispatcher.
 * Spec §8.6 — renders Desktop or Mobile based on viewport width.
 * index.tsx is the single import point for the rest of the app.
 */

import { useMediaQuery } from '../../hooks/useMediaQuery';
import { useProgressData } from '../../hooks/useProgressData';
import { ProgressSkeleton } from './ProgressSkeleton';
import { ProgressEmptyState } from './ProgressEmptyState';
import { ProgressTabDesktop } from './Desktop';
import { ProgressTabMobile } from './Mobile';

interface Props {
  domainId: string;
  domain: string;
  customerTier: string;
}

export function ProgressTab({ domainId, domain: _domain, customerTier }: Props) {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const data = useProgressData(domainId);

  if (data.status === 'loading') {
    return <ProgressSkeleton mobile={isMobile} />;
  }

  if (data.status === 'error') {
    const errorProp = { message: String(data.error?.message ?? 'Failed to load progress data'), retry: () => {} };
    return isMobile
      ? <ProgressTabMobile {...data} error={errorProp} domainId={domainId} customerTier={customerTier} />
      : <ProgressTabDesktop {...data} error={errorProp} domainId={domainId} customerTier={customerTier} />;
  }

  if (!data.thenAudit) {
    return <ProgressEmptyState />;
  }

  return isMobile
    ? <ProgressTabMobile {...data} domainId={domainId} customerTier={customerTier} />
    : <ProgressTabDesktop {...data} domainId={domainId} customerTier={customerTier} />;
}
